import { useState } from 'react'

import i18n from './i18n'
import css from './index.module.css'

import { updateGuarantee } from '#/local/repository'

import { Config } from '#/global/helper/Config'
import { MessageFlash } from '#/global/helper/MessageFlash'

interface Props {
    hasUserAgreedWithGuarantee: boolean
    price: number
    recordIdList: number[]
    setHasUserAgreedWithGuarantee: (hasUserAgreedWithGuarantee: boolean) => void
    unit: string
}

export const RentalGuarantee = ({ hasUserAgreedWithGuarantee, price, recordIdList, setHasUserAgreedWithGuarantee, unit }: Props) => {
    const t = i18n[Config.getLang()]

    const [isRequestInProcess, setIsRequestInProcess] = useState(false)

    const addGuarantee = async () => {
        setIsRequestInProcess(true)

        if (import.meta.env.DEV && recordIdList[0] === -1) {
            setIsRequestInProcess(false)
            setHasUserAgreedWithGuarantee(true)
            return
        }

        const results = await Promise.all(recordIdList.map(async recordId => updateGuarantee(recordId)))

        if (results.every(Boolean)) {
            setHasUserAgreedWithGuarantee(true)
        } else {
            MessageFlash.add({ message: t.error, type: 'error' })
        }

        setIsRequestInProcess(false)
    }

    return (
        <div className={`r-guarantee ${css.container}`}>
            <div>
                <h4>{t.title}</h4>
                <span className={css.subTitle}>{t.subText}</span>
            </div>
            <div className={css.wrap}>
                <div className={css.content}>{t.price(price, unit)}</div>
                {hasUserAgreedWithGuarantee && (
                    <div className={css.agreed}>
                        <img src="https://cdn1.idek.cz/file/check-7c33cfe0.svg" width={16} height={16} />
                        <span>{t.agreed}</span>
                    </div>
                )}
                {!hasUserAgreedWithGuarantee && (
                    <div>
                        <button
                            className={`dek-button-blue dek-button-small ${css.button}`}
                            disabled={isRequestInProcess}
                            onClick={() => void addGuarantee()}
                            role="button"
                            type="button">
                            {isRequestInProcess && <span className={css.loading} />}
                            {t.button}
                        </button>
                    </div>
                )}
            </div>
        </div>

    )
}
